import React, { useEffect, useState, useRef } from 'react';
import { Music, Play, Pause, Volume2, VolumeX } from 'lucide-react';
export const BackgroundMusic = () => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [volume, setVolume] = useState(0.5);
  const [isHovered, setIsHovered] = useState(false);
  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play().catch(error => {
          console.error('Audio playback failed:', error);
        });
      }
      setIsPlaying(!isPlaying);
    }
  };
  const handleVolumeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    if (audioRef.current) {
      audioRef.current.volume = newVolume;
    }
  };
  const toggleMute = () => {
    if (volume > 0) {
      setVolume(0);
      if (audioRef.current) audioRef.current.volume = 0;
    } else {
      setVolume(0.5);
      if (audioRef.current) audioRef.current.volume = 0.5;
    }
  };
  // Initialize volume and attempt autoplay
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = volume;
      // Attempt autoplay
      const playPromise = audioRef.current.play();
      if (playPromise !== undefined) {
        playPromise.then(() => {
          setIsPlaying(true);
        }).catch(error => {
          console.log('Autoplay prevented by browser policy:', error);
          setIsPlaying(false);
        });
      }
    }
  }, []);
  return <div className="fixed top-4 right-4 z-50 flex items-center gap-2 p-3 rounded-full bg-white/80 backdrop-blur-sm shadow-lg border border-red-200 transition-all duration-300 hover:bg-white hover:shadow-xl hover:scale-105" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-25">
      <audio ref={audioRef} src="https://cdn.pixabay.com/audio/2025/11/29/audio_d1c955f418.mp3" loop autoPlay data-id="element-26" />

      <div className="flex items-center gap-2" data-id="element-27">
        <button onClick={togglePlay} className="p-2 rounded-full bg-red-600 text-white hover:bg-red-700 transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2" aria-label={isPlaying ? 'Pause music' : 'Play music'} data-id="element-28">
          {isPlaying ? <Pause className="w-5 h-5" data-id="element-29" /> : <Play className="w-5 h-5 ml-0.5" data-id="element-30" />}
        </button>

        <div className={`flex items-center gap-2 overflow-hidden transition-all duration-300 ${isHovered || isPlaying ? 'w-32 opacity-100' : 'w-0 opacity-0'}`} data-id="element-31">
          <button onClick={toggleMute} className="text-slate-600 hover:text-red-600 transition-colors" aria-label={volume === 0 ? 'Unmute' : 'Mute'} data-id="element-32">
            {volume === 0 ? <VolumeX className="w-4 h-4" data-id="element-33" /> : <Volume2 className="w-4 h-4" data-id="element-34" />}
          </button>

          <input type="range" min="0" max="1" step="0.01" value={volume} onChange={handleVolumeChange} className="w-20 h-1.5 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-red-600" aria-label="Volume control" data-id="element-35" />
        </div>

        {!isHovered && !isPlaying && <Music className="w-5 h-5 text-red-600 animate-pulse" data-id="element-36" />}
      </div>
    </div>;
};